"use client"

import { Suspense } from "react"
import { Analytics as VercelAnalytics } from "@vercel/analytics/next"

import { MatomoAnalytics } from "@/components/analytics/matomo-analytics"
import { UIInteractionAnalytics } from "@/components/analytics/ui-interaction-analytics"

export function AnalyticsWrapper() {
  const ENABLE_PROD_ANALYTICS =
    process.env.NODE_ENV === "production" && process.env.NEXT_PUBLIC_ENABLE_ANALYTICS === "true"

  if (!ENABLE_PROD_ANALYTICS) {
    return null
  }

  return (
    <>
      <VercelAnalytics />
      <Suspense fallback={null}>
        <MatomoAnalytics />
      </Suspense>
      <UIInteractionAnalytics />
    </>
  )
}
